import { finishDemoCentering, getDemoScrollContainers, getDemoScrollDestination, getDemoVisibleBounds } from './scroll-geometry'
import { getDemoPlayerClock } from './player-clock'

export const centerDemoField = (element: Element) => {
  const clock = getDemoPlayerClock()

  if (clock && clock.manualScrollUntil > performance.now() && element.closest('.demo-player')) {
    return true
  }

  if (element.closest('.demo-player')) {
    // The playback clock waits while the player is outside the visual viewport.
    if (!getDemoVisibleBounds(element)) return true
    for (const container of getDemoScrollContainers(element)) {
      // Popup anchors update asynchronously; move their scene once per frame.
      if (container.contains(element)) {
        container.scrollTop = getDemoScrollDestination({ element, content: container })
      }
    }
    return finishDemoCentering(element)
  }

  return false
}

export const trackDemoField = (element: Element) => {
  let frame = 0
  const update = () => {
    if (!getDemoPlayerClock()?.paused) centerDemoField(element)
  }
  const tick = () => {
    update()
    frame = requestAnimationFrame(tick)
  }
  const observer = new ResizeObserver(update)
  const scene = element.closest('.MuiDialog-paper, .demo-calculator-canvas')
  const targets = [ element, element.parentElement, scene ]
  targets.forEach(target => {
    if (target) observer.observe(target)
  })
  tick()

  return () => {
    cancelAnimationFrame(frame)
    observer.disconnect()
  }
}
